<template>
  <div class="curr-bg">
    <div class="left-title d-aligncnter">
      <img class="img-24" src="@/assets/img/cockpit/trophy.svg" style="width: 24px; height: 24px" />
      <div class="ml-4">本期体测最好成绩</div>
    </div>
    <table class="left-table" cellspacing="0">
      <tr class="t-head">
        <td class="td-1">学生姓名</td>
        <td class="td-2">性别</td>
        <td class="td-3">所属学院</td>
        <!-- <td class="td-3">项目</td> -->
        <td class="td-2">成绩</td>
      </tr>
    </table>
    <div
      style="height: 330px; overflow: hidden"
      @mouseenter="stopScroll"
      @mouseleave="startScroll"
      @mousemove="updatexy"
    >
      <div :style="{ top: y - 200 + 'px', left: x + 20 + 'px' }" v-show="showInfoBox" class="infobox">
        <div style="font-weight: 600; margin-bottom: 8px">
          {{ currData.stuName }}-{{ currData.collegeName }}-成绩详情：
        </div>
        <table style="width: 300px">
          <thead>
            <th>项目</th>
            <th>成绩</th>
            <th>得分</th>
          </thead>
          <tr v-for="(item, index) in currData.itemScoreList" :key="'scorelist2_' + index">
            <td>
              <div v-if="currData.gender == '男' && item.itemName == '引体向上、一分钟仰卧起坐'">引体向上</div>
              <div v-else-if="currData.gender == '女' && item.itemName == '引体向上、一分钟仰卧起坐'">
                一分钟仰卧起坐
              </div>
              <div v-else-if="currData.gender == '男' && item.itemName == '1000米、800米'">1000米</div>
              <div v-else-if="currData.gender == '女' && item.itemName == '1000米、800米'">800米</div>
              <div v-else>{{ item.itemName }}</div>
            </td>
            <td>{{ item.result }}</td>
            <td>{{ item.score }}</td>
          </tr>
        </table>
      </div>
      <table class="left-table" cellspacing="0" :class="{ 'animated-top': animatedTop && this.stuData.length > 8 }">
        <tr
          class="tr-data"
          :class="{ 'color-tr': getBgClass(index) }"
          v-for="(item, index) in stuData"
          :key="'stu_' + index"
          @mouseenter="showInfo(item, index)"
        >
          <td class="td-1">{{ item.stuName }}</td>
          <td class="college-name td-2 overflow">
            {{ item.gender }}
          </td>
          <td class="td-3">{{ item.collegeName }}</td>
          <!-- <td class="td-3">{{ item.itemName }}</td> -->
          <td class="td-2">{{ item.maxScore }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  props: ['bestData'],
  data() {
    return {
      stuData: [],
      animatedTop: false,
      timer: null,
      flag: true,
      showInfoBox: false,
      currData: {},
      currIndex: -1,
      x: '',
      y: '',
    }
  },
  watch: {
    bestData: {
      handler: function () {
        this.stuData = this.bestData
      },
      deep: true,
    },
  },
  created() {
    this.stuData = this.bestData
  },
  mounted() {
    this.timer = setInterval(() => {
      if (this.stuData.length > 8) {
        this.animatedTop = true
        setTimeout(() => {
          this.stuData.push(this.stuData[0])
          this.stuData.shift()
          this.animatedTop = false
        }, 500)
      } else {
        this.stopScroll()
      }
    }, 2000)
  },
  computed: {
    getBgClass() {
      return function (index) {
        if (index % 2 == 0) {
          return false
        }
        return true
      }
    },
  },
  methods: {
    updatexy(event) {
      this.x = event.pageX
      this.y = event.pageY
    },
    showInfo(item, index) {
      console.log('item', item)
      this.currData = item
      this.currIndex = index
      this.showInfoBox = true
    },
    stopScroll() {
      clearInterval(this.timer)
      this.timer = null
    },
    startScroll() {
      this.showInfoBox = false
      this.timer = setInterval(() => {
        if (this.stuData.length > 8) {
          this.animatedTop = true
          setTimeout(() => {
            this.stuData.push(this.stuData[0])
            this.stuData.shift()
            this.animatedTop = false
          }, 500)
        } else {
          this.stopScroll()
        }
      }, 2000)
    },
  },
}
</script>
<style scoped lang="scss">
@import '@/assets/css/academic.scss';
.animated-top {
  transition: all 0.5s;
  margin-top: -30px;
}
.left-title {
  font-size: 22px;
  margin-bottom: 8px;
}
.left-box {
  width: calc(100% - 48px);
  margin-left: 24px;

  .left-table {
    width: calc(100% - 0px);
    font-size: 16px;
    white-space: nowrap;
    overflow: hidden;
    border-radius: 4px;
  }
}
table {
  table-layout: fixed;
  width: 100%;
  tr td {
    text-align: center;
    height: 30px;
    // height: 3vh;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .t-head {
    width: 100%;
    background: linear-gradient(0deg, rgba(6, 88, 58, 0.0884779) -24.83%, #06583a 100%);
    height: 36px;
    // height: 4vh;
  }
  tr {
    cursor: pointer;
    width: 100%;
    .td-1 {
      width: 15%;
    }
    .td-2 {
      width: 10%;
    }
    .td-3 {
      width: 30%;
    }
    .td-4 {
      width: 30%;
    }
  }
  .color-tr {
    background: rgba(0, 122, 77, 0.2);
  }
  //   .tr-data {
  // .college-name {
  //   text-align: left;
  // }
  //   }
}
.curr-bg {
  margin: 0 16px;
  padding: 16px;
  height: 376px;
  background: linear-gradient(0deg, rgba(0, 122, 77, 0.1) 80%, rgba(0, 122, 77, 0.1) 100%);
}
.infobox {
  position: absolute;
  z-index: 999;
  background: #ededed;
  color: #000;
  font-size: 16px;
  //   left: calc(14vw - 84px);
  padding: 16px;
  border-radius: 4px;
}
// .eachinfo {
//   line-height: 0.4rem;
// }
</style>
